
  import { Component, Vue ,Model,Watch,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Dialog from './dialog.vue';
  import {
    activityWheelSurfactivityWheelSurf,
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Model('change') show!:boolean
    @Prop({default:{}}) data!:any
    private dialogshow = false
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 10
    private total = 0
    private choosemsg:any = {}

    
    @Watch('show')
    private getshow(e){
      this.dialogshow = e
      if(e){
        this.choosemsg = this.data
        this.pageNo = 1
        this.gettablelist()
      }
    }







    private changechoose(e,row){
      if(e){
        this.choosemsg = row
      }else{
        this.choosemsg = {}
      }
      this.tablelist = this.tablelist.map(v=>{
        v.IsChoose = false
        if(v.Id==row.Id){
          v.IsChoose = e
        }
        return v
      })
    }
    private confirm(){
      if(!this.choosemsg||!this.choosemsg.Id){
        this.$message.error('请选择一个抽奖活动')
        return
      }
      this.$emit('getData',this.choosemsg)
    }
    private doSearch(){
      this.changePage(1)
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activityWheelSurfactivityWheelSurf({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.IsChoose = v.Id==this.data.Id
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private close(){
      this.dialogshow = false
      this.$emit('close')
    }
  }
